import packageJson from '../../package.json';

export function usePackageJson(): { version: string; dependencies: {[name: string]: string} } {
    return packageJson;
}
